const trackedMutations = {
  // Let tracking know this is an authenticated user
  'user/USER_TOKEN_SET': ({user: {profile: {account_id}}}) => {
    if (account_id) {
      window.dataLayer.push({user: {account_id}})
    }
  }
}

const trackingPlugin = (store) => {
  store.subscribe((mutation, state) => {
    trackedMutations[mutation.type]?.(state, mutation.payload)
  });
}

export default trackingPlugin